import { z } from 'zod';
import { api, unwrap } from '@/lib/api';
import type { LoginResponse, User } from '@/types';

export const loginSchema = z.object({
  email: z.string().email('請輸入有效的 Email'),
  password: z.string().min(1, '請輸入密碼'),
});
export type LoginInput = z.infer<typeof loginSchema>;

const userSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  role: z.enum(['admin', 'staff']),
  line_user_id: z.string().nullable().optional(),
  is_active: z.boolean(),
  last_login_at: z.string().nullable().optional(),
});

const loginResponseSchema = z.object({
  access_token: z.string(),
  token_type: z.literal('bearer'),
  user: userSchema,
});

export async function login(input: LoginInput): Promise<LoginResponse> {
  const { data } = await api.post('/auth/login', input);
  return loginResponseSchema.parse(unwrap(data));
}

export async function fetchCurrentUser(): Promise<User> {
  const { data } = await api.get('/auth/me');
  return userSchema.parse(unwrap(data));
}

export async function logout(): Promise<void> {
  try {
    await api.post('/auth/logout');
  } catch {
    /* server-side logout is best-effort */
  }
}
